import React from 'react'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts'
import type { Aggregates } from '../lib/types'

export const InsightCharts: React.FC<{ aggregates: Aggregates }> = ({ aggregates }) => {
  if (aggregates.n === 0) return null

  const axisData = [
    { axis: 'Fragmentation', value: aggregates.avgFrag },
    { axis: 'Recovery', value: aggregates.avgRecovery },
    { axis: 'Readiness', value: aggregates.avgReadiness },
    { axis: 'Clarity', value: aggregates.avgClarity },
  ]

  const barData = [
    { name: 'High frag', value: aggregates.highFragCount },
    { name: 'High recovery', value: aggregates.highRecoveryCount },
    { name: 'Low clarity', value: aggregates.lowClarityCount },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs">
      <div className="card p-3">
        <div className="mb-1 text-[#8a7560]">Average load profile</div>
        <div style={{ height: 168 }}>
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart data={axisData} outerRadius={62}>
              <PolarGrid stroke="#d4c8b5" />
              <PolarAngleAxis dataKey="axis" tick={{ fill: '#5c4636', fontSize: 10 }} />
              <PolarRadiusAxis domain={[0, 10]} tick={false} axisLine={false} />
              <Radar name="load" dataKey="value" stroke="#2f3459" fill="#2f3459" fillOpacity={0.25} />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="card p-3">
        <div className="mb-1 text-[#8a7560]">Notable clusters (count)</div>
        <div style={{ height: 168 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={barData}>
              <XAxis dataKey="name" tick={{ fill: '#6b5c4a', fontSize: 10 }} />
              <YAxis domain={[0, Math.max(aggregates.n, 4)]} tick={{ fill: '#6b5c4a', fontSize: 10 }} />
              <Bar dataKey="value" fill="#9c6644" radius={2} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="text-[10px] text-[#8a7560] mt-1">N = {aggregates.n}. Anonymous only.</div>
      </div>
    </div>
  )
}
